import React from 'react'
import NoAvatar from '../../../../ui/NoAvatar/NoAvatar'
import OutletBlock from '../../../../ui/OutletBlock/OutletBlock'
import { getPublicSiteUrl } from '../../../../config/publicSite'
import { isValidProductSlug } from '../../../Products/productSchema/productSlug'
import styles from './OrderManager.module.scss'

const getProductSiteUrl = (slug, isOutlet) => {
  if (!isValidProductSlug(slug)) return null
  const base = getPublicSiteUrl()
  return isOutlet ? `${base}/outlet/${slug}` : `${base}/products/${slug}`
}

const resolveAvatarSrc = ({ productId, avatar, avatarSrc }) => {
  if (typeof avatarSrc === 'string' && avatarSrc.trim()) {
    return avatarSrc.trim()
  }
  if (avatar?.fileName && productId) {
    return `https://storage.googleapis.com/amecos.firebasestorage.app/products/${productId}/thumbs/${avatar.fileName}_300x300.webp`
  }
  return null
}

function OrderProductCell({ row }) {
  const {
    productId,
    slug,
    avatar,
    avatarSrc,
    name,
    descriptionShort,
    isOutlet,
    isGift,
    outletReason,
    expirationOption,
    missingExpirationOption,
    outletOptionId,
  } = row

  const imageSrc = resolveAvatarSrc({ productId, avatar, avatarSrc })
  const siteUrl = !isGift ? getProductSiteUrl(slug, isOutlet) : null

  return (
    <div className={styles.orderProductCell}>
      {imageSrc ? (
        <img className={styles.orderProductAvatar} src={imageSrc} alt={name} />
      ) : (
        <div className={styles.orderProductAvatarPlaceholder}>
          <NoAvatar />
        </div>
      )}

      <div className={styles.orderProductContent}>
        <p className={styles.orderProductTitle}>{name}</p>
        {descriptionShort ? <p className={styles.orderProductDescription}>{descriptionShort}</p> : null}

        {isGift ? (
          <p className={styles.orderProductDescription}>Подарунок до замовлення · 0 ₴</p>
        ) : null}

        {isOutlet && (
          <div className={styles.orderProductOutletMeta}>
            <OutletBlock
              compact
              outletReason={outletReason}
              expirationOption={expirationOption}
              missingExpirationOption={missingExpirationOption}
              outletOptionId={outletOptionId}
            />
          </div>
        )}

        {siteUrl ? (
          <a
            className={styles.productSiteLink}
            href={siteUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {isOutlet ? 'Відкрити в Outlet каталозі' : 'Відкрити в Premium каталозі'}
          </a>
        ) : null}
      </div>
    </div>
  )
}

export default OrderProductCell
